import React, { Component } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import classnames from "classnames";
import { Link } from "react-router-dom";
import FiltertRightbar from "../FiltersRightbar";
import { connect } from "react-redux";
import TimeLineLogRightbar from "../TimeLineLogRightbar";
import AllMaterial from "./AllMaterial";

import {
  SetParams,
  getMyMeterialReqList,
  // getMyMRListcount,
  listlayout,
  FiltersShowRightSidebar,
  FilterClear,
} from "../../../store/MaterialRequest/actions";

import "../../../assets/scss/dashboard.scss";
import LoadingModel from "../../LoadingModel";

class MyMRDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 1,
      currentPage: 1,
      FilterToggle: false,
      dropdownOpen: false,
    };
    // this.toggleTab = this.toggleTab.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  // toggleTab(tab) {
  //   var mrstatus = [0];
  //   if (tab === 1) {
  //     mrstatus = [0];
  //   } else if (tab !== 2) {
  //     if (tab === 3) {
  //       mrstatus = [3, 5, 7, 8];
  //     } else if (tab === 4) {
  //       mrstatus = [4, 6];
  //     }
  //   } else if (tab === 2) {
  //     mrstatus = [1, 2];
  //   }
  //   this.props.getMyMeterialReqList({
  //     ...this.props.params,
  //     mrstatus: mrstatus,
  //     page: 1,
  //   });

  //   this.props.SetParams({
  //     ...this.props.params,
  //     mrstatus: mrstatus,
  //     page: 1,
  //   });
  // }
  componentDidMount() {
    this.setState({ activeTab: 1 });
    this.props.FilterClear();
    // this.props.getMyMRListcount();
    this.props.listlayout("list");
    this.props.SetParams({
      ...this.props.params,
      mrstatus: [0],
      pistatus: [0],
      mistatus: [0],
      search: "",
      start_date: "",
      end_date: "",
      userdepartment: "",
      departments: "",
      location:"",
      mritems__product:"",
    });
    this.props.getMyMeterialReqList({
      ...this.props.params,
      mrstatus: [0],
      pistatus: [0],
      mistatus: [0],
      search: "",
      start_date: "",
      end_date: "",
      userdepartment: "",
      departments: "",
      location:"",
      mritems__product:"",
    });
  }

  filters() {
    this.props.FiltersShowRightSidebar(1);
  }
  toggle() {
    this.setState((prevState) => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  }
  getMRlist(tab) {
    this.setState({ activeTab: tab });
    var mrstatus = [0];
    var pistatus = [0];
    var mistatus = [0];
    if (tab === 1) {
      // All
      mrstatus = [0];
      pistatus = [0];
      mistatus = [0];
    } else if (tab === 2) {
      // MR Pending
      mrstatus = [1, 2];
      pistatus = [0];
      mistatus = [0];
    } else if (tab === 3) {
      // MR Approved
      mrstatus = [3, 5, 9, 10, 11, 12];
      pistatus = [0];
      mistatus = [0];
    } else if (tab === 4) {
      // MR Rejected
      mrstatus = [4, 6];
      pistatus = [0];
      mistatus = [0];
    } else if (tab === 5) {
      //  PI Pending
      mrstatus = [3, 5, 9, 10, 11, 12];
      pistatus = [1, 2];
      mistatus = [0];
    } else if (tab === 6) {
      // PI Completed
      mrstatus = [3, 5, 9, 10, 11, 12];
      pistatus = [3];
      mistatus = [0]; //1,2,3
    } else if (tab === 7) {
      // MI Pending
      mrstatus = [3, 5, 9, 10, 11, 12];
      pistatus = [0];
      mistatus = [1, 2, 3];
    } else if (tab === 8) {
      //  MI Completed
      mrstatus = [3, 5, 9, 10, 11, 12];
      pistatus = [0];
      mistatus = [4];
    }else if (tab === 9) {
      //  MI Completed
      mrstatus = [0];
      pistatus = [0];
      mistatus = [5];
    }
    this.props.SetParams({
      ...this.props.params,
      mrstatus: mrstatus,
      pistatus: pistatus,
      mistatus: mistatus,
      search: "",
      start_date: "",
      end_date: "",
      userdepartment: "",
      departments: "",
    });
    this.props.getMyMeterialReqList({
      ...this.props.params,
      mrstatus: mrstatus,
      pistatus: pistatus,
      mistatus: mistatus,
      search: "",
      start_date: "",
      end_date: "",
      userdepartment: "",
      departments: "",
    });
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content ">
          <Container fluid>
            {this.props.loading && (
              <LoadingModel OpenModel={this.props.loading} />
            )}

            <Row>
              <Col lg={12}>
                <Card className="pagebody">
                  <CardHeader className="bg-transparent border-bottom">
                    <div className="d-inline-block">
                      <h5 className="card-title-18 pt-2 d-flex">
                        <span className="d-none d-lg-block">
                          Material Request
                        </span>
                        <span className="d-lg-none">MR</span>
                        <span className="pl-1"> Dashboard</span>
                      </h5>
                    </div>

                    <div className="float-right d-inline-block">
                      <div className="d-inline-block">
                        <Dropdown
                          isOpen={this.state.dropdownOpen}
                          toggle={this.toggle}
                          className="d-flex mr-2"
                        >
                          <DropdownToggle
                            caret
                            color="primary"
                            className="d-flex mr-2"
                          >
                            <i className="mdi mdi-rotate-right"></i>
                            <span className="d-none d-lg-block ml-1">
                              MR List
                            </span>
                          </DropdownToggle>
                          <DropdownMenu>
                            {/* <DropdownItem header>All</DropdownItem> */}
                            <DropdownItem onClick={() => this.getMRlist(1)}>
                              All
                            </DropdownItem>
                            <DropdownItem divider />
                            <DropdownItem onClick={() => this.getMRlist(2)}>
                              MR Pending
                            </DropdownItem>
                            <DropdownItem onClick={() => this.getMRlist(3)}>
                              MR Approved
                            </DropdownItem>
                            <DropdownItem onClick={() => this.getMRlist(4)}>
                              MR Rejected
                            </DropdownItem>
                            <DropdownItem divider />
                            <DropdownItem onClick={() => this.getMRlist(5)}>
                              PI Process
                            </DropdownItem>
                            <DropdownItem onClick={() => this.getMRlist(6)}>
                              PI Completed
                            </DropdownItem>
                            <DropdownItem divider />
                            <DropdownItem onClick={() => this.getMRlist(7)}>
                              MI Process
                            </DropdownItem>
                            <DropdownItem onClick={() => this.getMRlist(8)}>
                              MI Completed
                            </DropdownItem>
                            <DropdownItem onClick={() => this.getMRlist(9)}>
                              MI Closed
                            </DropdownItem>
                          </DropdownMenu>
                        </Dropdown>
                      </div>
                      <div className="d-inline-block">
                        <Button
                          type="button"
                          color="light"
                          className="waves-effect waves-light d-flex mr-2"
                          onClick={() => {
                            this.setState({ activeTab: 1 });
                            this.props.getMyMeterialReqList({
                              ...this.props.params,
                              mrstatus: [0],
                              pistatus: [0],
                              mistatus: [0],
                              search: "",
                              start_date: "",
                              end_date: "",
                              userdepartment: "",
                              departments: "",
                            });
                            this.props.SetParams({
                              ...this.props.params,
                              mrstatus: [0],
                              pistatus: [0],
                              mistatus: [0],
                              search: "",
                              start_date: "",
                              end_date: "",
                              userdepartment: "",
                              departments: "",
                            });
                          }}
                        >
                          <i className="mdi mdi-rotate-right"></i>
                          <span className="d-none d-lg-block ml-1">
                            Refresh
                          </span>
                        </Button>
                      </div>
                      <div className="d-inline-block">
                        <Button
                          type="button"
                          color="light"
                          className="waves-effect waves-light d-flex  mr-2"
                          onClick={() => this.filters()}
                        >
                          <i className="mdi mdi-filter"></i>
                          <span className="d-none d-lg-block ml-1">
                            Filters
                          </span>
                        </Button>
                      </div>

                      <div className="d-inline-block">
                        <Link to="/newmaterialrequest/0">
                          <Button
                            type="button"
                            color="primary"
                            className="waves-effect waves-light d-flex"
                          >
                            <i className="mdi mdi-plus-circle-outline"></i>
                            <span className="d-none d-lg-block ml-1">
                              Request Material
                            </span>
                          </Button>
                        </Link>
                      </div>
                    </div>
                  </CardHeader>
                  <CardBody className="pt-0">
                    <Nav tabs className="nav-tabs-custom ">
                      <NavItem>
                        <NavLink
                          className={classnames(
                            { active: true },
                            "pt-3 font-weight-bold card-title-16"
                          )}
                        >
                          {this.state.activeTab === 1
                            ? "All "
                            : this.state.activeTab === 2
                            ? "Pending "
                            : this.state.activeTab === 3
                            ? "Approved "
                            : this.state.activeTab === 4
                            ? "Rejected "
                            : this.state.activeTab === 5
                            ? "PI Process "
                            : this.state.activeTab === 6
                            ? "PI Completed "
                            : this.state.activeTab === 7
                            ? "MI Process "
                            : this.state.activeTab === 8
                            ? "MI Completed "
                            : ""}
                          | <span>{this.props.mrRowlistcount} </span>
                        </NavLink>
                      </NavItem>
                    </Nav>

                    <TabContent>
                      <AllMaterial activeTab={this.state.activeTab} />
                    </TabContent>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <FiltertRightbar />
            <TimeLineLogRightbar />
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { mrRowList, mrRowlistcount, params, loading } = state.Materialrequest;
  return {
    mrRowList,
    mrRowlistcount,
    // mrListCount,
    params,
    loading,
  };
};

export default connect(mapStatetoProps, {
  SetParams,
  getMyMeterialReqList,
  // getMyMRListcount,
  listlayout,
  FiltersShowRightSidebar,
  FilterClear,
})(MyMRDashboard);
